import styled from 'styled-components'

export const LeasingPage = styled.div`
  flex: 1;
  display: flex;
`

export const LeasingPageBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const LeasingPageDetail = styled.div`
  display: flex;
  flex: initial;
  flex-direction: column;
  width: 380px;
`

export const Body = styled.div`
  box-sizing: border-box;
  max-width: 579px;
  padding: 0 32px 64px 48px;
`

export const ScrollPane = styled.div`
  flex: 1;
  height: 100%;
  overflow-x: hidden;
  overflow-y: overlay;
`

export const ScrollPane2D = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  overflow-x: overlay;
  overflow-y: overlay;
`
